//#region types
import { InvoiceReminderSectionProps } from "models/propTypes/invoicePropTypes";
import { TranslationKeys } from "translations";
import { IconDefinitionConstants } from "utils/constants";
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
//#endregion
//#region components
import {
  ReadOnlyVerticalFormField,
  TextDisplay,
  BooleanDisplay,
  GroupSectionInline,
} from "components/common/wintForms";
import { Grid } from "@mui/material";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";

const InvoiceReminderSection: React.FC<InvoiceReminderSectionProps> = (props) => {
  const { invoice, isRecurring, isAutomaticRemindersFeatureEnabled, values } = props;
  const hidden =
    isRecurring || !isAutomaticRemindersFeatureEnabled || (invoice as WintSuperkollAPIModel.Invoice)?.credit;
  const isAutomaticRemindersEnabled = (invoice as WintSuperkollAPIModel.Invoice)?.isAutomaticRemindersEnabled;

  return !hidden ? (
    <GroupSectionInline
      key={`invoice-reminder-section`}
      label={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Invoice.Reminders)}
      icon={IconDefinitionConstants.WBolt}
    >
      {!!values.isAutomaticRemindersEnabled && (
        <Grid item xs={6}>
          <ReadOnlyVerticalFormField
            Component={BooleanDisplay}
            value={values.isAutomaticRemindersEnabled}
            label={TranslationKeys.Invoice.AutomaticReminder}
          />
        </Grid>
      )}
      {!!values.automaticReminderPeriod && isAutomaticRemindersEnabled && (
        <Grid item xs={6}>
          <ReadOnlyVerticalFormField
            Component={TextDisplay}
            value={values.automaticReminderPeriod}
            label={TranslationKeys.Invoice.AutomaticReminderPeriodControlLabel}
          />
        </Grid>
      )}
      {!!values.automaticReminderDelay && isAutomaticRemindersEnabled && (
        <Grid item xs={6}>
          <ReadOnlyVerticalFormField
            Component={TextDisplay}
            value={values.automaticReminderDelay}
            label={TranslationKeys.Invoice.AutomaticReminderDelayControlLabel}
          />
        </Grid>
      )}
      {!!values.automaticReminderAmountLimit && isAutomaticRemindersEnabled && (
        <Grid item xs={6}>
          <ReadOnlyVerticalFormField
            Component={TextDisplay}
            value={values.automaticReminderAmountLimit}
            label={TranslationKeys.Invoice.AutomaticReminderAmountLimitControlLabel}
          />
        </Grid>
      )}
      {!!values.automaticReminderCountLimit && isAutomaticRemindersEnabled && (
        <Grid item xs={6}>
          <ReadOnlyVerticalFormField
            Component={TextDisplay}
            value={values.automaticReminderCountLimit}
            label={TranslationKeys.Invoice.AutomaticReminderCountLimitControlLabel}
          />
        </Grid>
      )}
      {!!values.automaticReminderSendMethod && isAutomaticRemindersEnabled && (
        <Grid item xs={6}>
          <ReadOnlyVerticalFormField
            Component={TextDisplay}
            value={values.automaticReminderSendMethod}
            label={TranslationKeys.Invoice.AutomaticReminderSendType}
          />
        </Grid>
      )}
      {!!values.automaticReminderMailToAddresses && isAutomaticRemindersEnabled && (
        <Grid item xs={6}>
          <ReadOnlyVerticalFormField
            Component={TextDisplay}
            value={values.automaticReminderMailToAddresses}
            label={TranslationKeys.Invoice.SendEmailTo}
          />
        </Grid>
      )}
    </GroupSectionInline>
  ) : (
    <></>
  );
};

export default InvoiceReminderSection;
